<template>
  <div v-show="isshow">
  </div>
</template>

<script type="text/babel">
  import { mapGetters } from 'vuex';
  import Socket from '../../scripts/socket/index'
  import { emitEvent } from '../../utils/eventBus/vueEvent'
  import Events from '../../scripts/events/index'
  import consoleStyle from '../ide/consoleStyle'
  import timer from '../../scripts/timer';
  import Question from '../../scripts/common/question'

  let self;

  export default {
    name: 'c-socket-func',
    data() {
      return {
        isshow: false,
      }
    },
    computed: {
      ...mapGetters(['isRunLocal', 'language']),
    },
    created() {
      self = this;
      Socket.setSocket(this);
    },
    mounted() {
    },
    methods: {
      async timerTestGetEnd(data) {
        if (!data || !data.SolutionID) {
          return
        }
        Socket.getTest(data.SolutionID, this.$route.query);
        timer.setTimer(this.timerTestGetEnd.bind(this), timer.timers.testGetEnd.time, timer.timers.testGetEnd.key, data);
      },
      testResHandler(res) {
        if (res.Code == 0) {
          if (res.data && res.data.SolutionID) {
            timer.setTimer(this.timerTestGetEnd.bind(this), timer.timers.testGetEnd.time, timer.timers.testGetEnd.key, res.data);
          }
        }
        emitEvent(Events.TEST_CODE_RES, res)
      },
      getTestResHandler(res) {
        if (res.Code == 0) {
          if (res.data && res.data.Status && res.data.Status != Question.testStatus.STATUS_SEND_SUCC.key) {
            emitEvent(Events.TEST_ENDED, res)
            return
          }
        } else {
          console.error('getTestResHandler err:', res)
        }
        if (res.data && res.data.SolutionID) {
          timer.setTimer(this.timerTestGetEnd.bind(this), timer.timers.testGetEnd.time, timer.timers.testGetEnd.key, res.data);
        }
      },
      socketOpen() {
        Socket.setSocket(this, this.$socket)
      }
    },
    sockets: {
      opend: () => {
        self.socketOpen()
      },
      outputed(data) {
        data.isOutput = true
        data.result = consoleStyle.getOutput(data.result);
        emitEvent(Events.OUTPUT_CONSOLE, data)
      },
      stoped(data) {
        emitEvent(Events.RUN_CODE_STOPED, data)
      },
      needInput(data) {
        emitEvent(Events.NEED_INPUT, data)
      },
      runRes(data) {
        emitEvent(Events.RUN_CODE_RUN_RES, data)
      },
      stopRes(data) {
        emitEvent(Events.RUN_CODE_STOP_RES, data)
      },
      inputRes(data) {
        emitEvent(Events.RUN_CODE_INPUT_RES, data)
      },
      testRes(data) {
        self.testResHandler(data)
      },
      getTestRes(data) {
        self.getTestResHandler(data)
      },
      testEnd(data) {
        emitEvent(Events.TEST_ENDED, data)
      },
      connect() {
        console.log('--socket--connect----')
      },
      disconnect() {
        console.warn('--socket--disconnect----', arguments)
      },
      reconnect() {
        console.log('--socket--reconnect----', arguments)
      }
    },
  }
</script>

<style lang="scss">
</style>
